import React from 'react';
import {
    Card,
    Divider,
} from 'antd';
import ServicesTable from '../../components/dashboard/ServicesTable';
import AddonsTable from '../../components/dashboard/AddonsTable';


const Services = () => {
    return (
        <Card title="Services List">
            <ServicesTable />
            <Divider />
            <AddonsTable />
        </Card>
    );
};

export default Services;
